import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=d105c526&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=ts&"
export * from "./ShopItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=d105c526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105c526",
  null
  
)

export default component.exports